import { __ } from '@wordpress/i18n';
import { defaultBackground } from '../../components/reusable/background/attributes';

export const attributes = {
	gsBlockId: {
		type: 'string',
		default: '',
	},
	background: {
		type: 'object',
		default: defaultBackground,
	},
	isEditable: {
		type: 'boolean',
		default: true,
	},
	mediaUrl: {
		type: 'string',
		source: 'attribute',
		selector: '.slide-bg img, .slide-bg video',
		attribute: 'src',
	},
	mediaAlt: {
		type: 'string',
		source: 'attribute',
		selector: '.slide-bg img',
		attribute: 'alt',
		default: '',
	},
	mediaType: {
		type: 'string',
	},
	mediaId: {
		type: 'number',
	},
	overlayColor: {
		type: 'string',
		default: '',
	},
	dimRatio: {
		type: 'number',
		default: 0.5,
	},
	rgbaBackground: {
		type: 'string',
		default: '',
	},
	initialized: {
		type: 'boolean',
		default: false,
	},
	linkUrl: {
		type: 'string',
		default: '',
	},
	verticalAlign: {
		type: 'string',
		default: 'center',
	},
	contentPosition: {
		type: 'string',
		default: 'center',
	},
	autoCaption: {
		type: 'string',
		default: 'none',
	},
	minWidth: {
		type: 'string',
		default: '67%',
	},
	mixBlendMode: {
		type: 'string',
		default: 'none',
	},
	opensInNewTab: {
		type: 'boolean',
		default: false,
	},
};

export const CAPTION_STYLES = [
	{ value: 'none', label: __( 'No Automatic Captions', 'gutenslider' ) },
	{ value: 'caption-only', label: __( 'Caption Only', 'gutenslider' ) },
	{ value: 'title-caption', label: __( 'Title - Caption', 'gutenslider' ) },
	{ value: 'title-caption-description', label: __( 'Title - Caption - Description', 'gutenslider' ) },
];
